import { useFlags } from 'flagsmith/react';
import { getVisibleFooterLinks } from './footerLinks';

export function useVisibleFooterSections(sections) {
  const { angling_trust_events: anglingTrustEvents } = useFlags([
    'angling_trust_events',
  ]);
  const enabledFlags = { angling_trust_events: anglingTrustEvents?.enabled };

  return sections
    .map((section) => ({
      ...section,
      links: getVisibleFooterLinks(section.links, enabledFlags),
    }))
    .filter(({ links }) => links.length);
}
